import { BulletList as BulletListToExtend } from '@tiptap/extension-bullet-list';

export const BulletList = BulletListToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: 'list-outside'
            },
            style: {
                default: null
            }
        }
    }
})
